import { AuthScene } from './AuthScene';

export function SignUpPage() {
  return <AuthScene mode="signup" />;
}
